exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-Info[data-v-29764fd2]{height:calc(100% - 50px)}.complete-button[data-v-29764fd2]{text-align:right;padding:20px}.no-border[data-v-29764fd2]{border:none;background-color:#fff}.center-info[data-v-29764fd2]{justify-content:center;padding:1rem}.buttom-info[data-v-29764fd2]{padding:2rem;text-align:center}.success-info[data-v-29764fd2]{font-weight:700;font-size:18px;color:#464646;text-align:center}.tickes-info[data-v-29764fd2]{font-size:15px;color:#7d7d7d;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29764fd2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/add/AddRelationshipSuccess.vue
// module id = 794
// module chunks = 0